import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { PrimaryNavItem } from '@hdms/shared/page-frame/types';
import { PlatformService } from '@hdms/shared/util-core';

@Component({
  selector: 'shrd-pf-ft-mega-menu',
  templateUrl: './header-mega-menu.component.html',
  styleUrls: ['./header-mega-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMegaMenuComponent {
  readonly isBrowser = inject(PlatformService).isBrowser;

  @Input() primaryNavItems: PrimaryNavItem[];

  trackById(_index: number, item: PrimaryNavItem): string {
    return item.id;
  }
}
